import { useParams, Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useUser } from '@/modules/users/hooks/useUser'
import { UserForm } from '@/modules/users/components/UserForm'
import { useUserMutation } from '@/modules/users/hooks/useUserMutation'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'

export function UserEditPage() {
  const { id } = useParams<{ id: string }>()
  const userId = Number(id)
  const { data, isLoading, error: loadError } = useUser(userId)
  const { update, isSubmitting, error: mutationError } = useUserMutation()

  if (isLoading) {
    return <div className="animate-pulse h-96 bg-gray-100 rounded-lg" />
  }

  if (loadError) {
    return <ErrorState message={loadError} />
  }

  if (!data) return null

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Link to="/users" className="text-gray-500 hover:text-gray-700">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-2xl font-bold text-gray-900">Editar Vendedor</h1>
      </div>
      <div className="card p-6">
        <UserForm
          mode="edit"
          defaultValues={{
            name: data.name,
            last_name: data.last_name,
            rut: data.rut,
            email: data.email,
            password: '',
            id_branch_office: data.id_branch_office,
          }}
          onSubmit={(formData) => update(userId, formData)}
          isSubmitting={isSubmitting}
          error={mutationError}
        />
      </div>
    </div>
  )
}
